import axios from 'axios';

const applicationApi = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER_URL,
});

let currentWorkspaceTenant: string | null = null;

export const setWorkspaceTenant = (tenantId: string | null) => {
  currentWorkspaceTenant = tenantId;
};

/**
 * Make a request that skips the workspace tenant header.
 * Use this for org-page stats that should always show global counts.
 */
export const skipWorkspaceConfig = () => ({
  headers: { 'X-Skip-Workspace': 'true' },
});

// https://stackoverflow.com/questions/69011315/how-to-get-auth0-token-from-outside-react-components
// this interceptor is only added when the auth0 instance is ready and exports the getAccessTokenSilently method
export const registerAxiosInterceptors = (refreshToken: () => Promise<string | void>) => {

  // Register request interceptor
  applicationApi.interceptors.request.use(async (config) => {
    let token = await refreshToken()
    config.headers.Authorization = `Bearer ${token}`;
    if (currentWorkspaceTenant && config.headers['X-Skip-Workspace'] !== 'true') {
      config.headers['X-Workspace-Tenant'] = currentWorkspaceTenant;
    } else {
      delete config.headers['X-Workspace-Tenant'];
    }
    delete config.headers['X-Skip-Workspace'];
    return config;
  });

};
export default applicationApi;
